<template>
  <div>
    <div class="card card-custom gutter-b">
      <div class="card-header card-header-tabs-line">
        <ul
          class="nav nav-dark nav-bold nav-tabs nav-tabs-line"
          role="tablist"
          ref="builder-tab"
        >
          <li class="nav-item">
            <a
              class="nav-link active"
              data-tab="0"
              data-toggle="tab"
              href="#"
              role="tab"
            >
              Cadastro
            </a>
          </li>
        </ul>
      </div>
      <b-form class="form" @submit.stop.prevent="onSubmit">
        <div class="card-body">
          <b-tabs class="hide-tabs" v-model="tabIndex">
            <b-tab active>
              <b-row>
                <b-col md="2"></b-col>
                <b-col md="8">
                  <b-row>
                    <b-col md="3">
                      <b-form-group
                        id="id_faixa_revenda"
                        label-for="id_faixa_revenda"
                        label="Classificação Revenda"
                      >
                        <b-form-select
                          v-model="$v.form.id_faixa_revenda.$model"
                          :state="validateState('id_faixa_revenda')"
                        >
                          <b-form-select-option
                            v-for="(faixa, index) in revendas.faixa"
                            :key="'faixa' + index"
                            :value="faixa['ID_FAIXA']"
                          >
                            {{ faixa["DESCRICAO"] }}
                          </b-form-select-option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col md="6">
                      <b-form-group
                        id="id_kit"
                        label-for="id_kit"
                        label="ID Kit"
                      >
                        <b-form-select
                          v-model="$v.form.id_kit.$model"
                          :state="validateState('id_kit')"
                          @change="setvalor"
                          class="mb-3"
                        >
                          <b-form-select-option
                            v-for="(kit, index) in revendas.kit"
                            :key="'id_kit' + index"
                            :value="kit['ID_KIT']"
                          >
                            {{ kit["ID_KIT"] + " - " + kit["DESCRICAO"] }}
                          </b-form-select-option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col md="3">
                      <b-form-group id="valor" label-for="valor" label="Valor">
                        <money
                          disabled
                          class="form-control"
                          v-model="form.valor"
                          v-bind="configMoney"
                        >
                        </money>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </div>
        <div class="card-footer">
          <div class="row">
            <div class="col-lg-12" style="text-align: center">
              <button
                type="submit"
                ref="submit_nova_valor"
                class="btn btn-primary mr-2"
              >
                Salvar
              </button>
              <button
                type="button"
                v-on:click="
                  () => {
                    $router.go(-1);
                  }
                "
                class="btn btn-secondary"
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import ProdutosValorData, { ProdutosValorDataRequired } from "./Data";
import ApplicationMixin from "@/modules/Application/mixins/SistemaMixin";
import { Money } from "v-money";
import { MONEY as settingMoney } from "@/modules/Application";

export default {
  name: "app-config-renovacoes-valor-form",
  props: {
    url: {
      type: String
    },
    valor: {
      type: Object,
      default: () => {}
    }
  },
  mixins: [validationMixin, ApplicationMixin],
  components: {
    Money
  },
  data() {
    return {
      configMoney: settingMoney,
      tabIndex: 0,
      form: {},
      revendas: {}
    };
  },
  validations: {
    form: ProdutosValorDataRequired
  },
  mounted() {
    this.getDataInit();
  },
  methods: {
    async setvalor(idKit) {
      const kit = this.revendas.kit.find(K => K["ID_KIT"] == idKit);
      this.form.valor = kit["VLR_UNITARIO"]
        ? this.numberToReal(kit["VLR_UNITARIO"])
        : 0;
    },
    async getRevendas() {
      try {
        const { data } = await this.$http.post("/renovacoes/revendas");
        this.revendas = data;
      } catch {
        return [];
      }
    },
    async getDataInit() {
      this.getRevendas();

      if (this.valor.id) {
        this.form = this.valor;
        this.form.valor = this.numberToReal(this.form.valor);
        return;
      }

      this.form = new ProdutosValorData({});
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    async onSubmit() {
      const submitButton = this.$refs["submit_nova_valor"];

      try {
        this.$v.form.$touch();

        if (this.$v.form.$anyError) {
          return;
        }

        submitButton.classList.add("spinner", "spinner-light", "spinner-right");

        await this.$http.post(this.url, this.form);

        this.$toast.success("Operação realizada com suceso!");

        this.$router.push({ name: "configuracoesRenovacaoLista" });
      } catch (error) {
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
      }
    }
  }
};
</script>

<style>
.vs__dropdown-toggle {
  border: 2px solid #dedede;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 6px;
  outline: none;
  height: 38px;
}
</style>
